import { RightNavMode } from "@/lib/utilities/enums";

const state = {
  RightNavSection: {
    Mode: RightNavMode.Overlay, // Specifies the layout for RightNav
    Type: 0, // Specify the component to load
    Subtype: "", // Specifies additional info for the loaded component
    Filter: null, // Specifies filters (if any) for the loaded component
    Previous: null // Specifies info for any component loaded previously to navigate back
  },
  ModalManager: {
    stack: [],
  },
};

const getters = {};

const actions = {
  updateRightNavSection(context, data) {
    context.commit("updateRightNavSection", data);
  },
  closeRightNavSection(context) {
    context.commit("closeRightNavSection");
  },
  loadPreviousContentInRightNavSection(context) {
    if (state.RightNavSection.Previous)
      context.commit("loadPreviousContentInRightNavSection");
    else context.commit("closeRightNavSection");
  },
  openModalManagerModal(context, data) {
    if (!data.payload) data.payload = {};
    context.commit("openModalManagerModal", data);
  },
  closeModalManagerModal(context, data) {
    context.commit("closeModalManagerModal", data);
  },
};

const mutations = {
  updateRightNavSection(state, data) {
    if (!data.RemovePreviousState) {
      let previousState = JSON.parse(JSON.stringify(state.RightNavSection));
      state.RightNavSection.Previous = previousState;
    }

    state.RightNavSection.Mode = data.Mode || RightNavMode.Overlay;
    state.RightNavSection.Type = data.Type;
    state.RightNavSection.Subtype = data.Subtype;
    state.RightNavSection.Filter = data.Filter;
  },
  closeRightNavSection(state) {
    state.RightNavSection.Mode = RightNavMode.Overlay;
    state.RightNavSection.Type = 0;
    state.RightNavSection.Subtype = null;
    state.RightNavSection.Filter = null;
    state.RightNavSection.Previous = null;
  },
  loadPreviousContentInRightNavSection(state) {
    state.RightNavSection.Mode =
      state.RightNavSection.Previous.Mode || RightNavMode.Overlay;
    state.RightNavSection.Type = state.RightNavSection.Previous.Type;
    state.RightNavSection.Subtype = state.RightNavSection.Previous.Subtype;
    state.RightNavSection.Filter = state.RightNavSection.Previous.Filter;
    state.RightNavSection.Previous = state.RightNavSection.Previous.Previous;
  },
  openModalManagerModal(state, data) {
    if (state.ModalManager.stack.includes(data)) {
      console.warn(
        `Trying to add modal to ModalManager which is already being displayed.. Skipping. `
      );
      return;
    }
    state.ModalManager.stack.push(data);
  },
  closeModalManagerModal(state, data) {
    state.ModalManager.stack = state.ModalManager.stack.filter((m) => m !== data);
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/RightNavSection.js